import React from "react"
import { ParagraphData } from "src/models/viewer/paragraph/ParagraphData"

import styles from "./index.module.scss"

export type ParagraphProps = {
  data: ParagraphData | string
}

const Paragraph: React.FC<ParagraphProps> = ({ data }) => {
  if (typeof data === "string") {
    if (data === "") {
      return (
        <p className={`${styles.normalText} ${styles.empty}`}>
          <br />
        </p>
      )
    }

    return <p className={styles.normalText}>{data}</p>
  } else {
    const body = data.texts.map((span, idx) => {
      if (typeof span === "string") {
        return <span key={idx}>{span}</span>
      } else {
        if (span.meta) {
          if (span.meta.some((x) => x.type === "ruby")) {
            const meta = span.meta.find((x) => x.type === "ruby")
            if (meta && meta.type === "ruby") {
              return <Ruby text={span.text} value={meta.value} key={`${idx}`} />
            }
          } else if (span.meta.some((x) => x.type === "exclamation")) {
            const meta = span.meta.find((x) => x.type === "exclamation")
            if (meta && meta.type === "exclamation") {
              return <Exclamation text={span.text} key={`${idx}`} />
            }
          } else if (span.meta.some((x) => x.type === "dot")) {
            return <Dot text={span.text} key={`${idx}`} />
          }
        } else {
          return <span key={idx}>{span.text}</span>
        }
      }
    })

    return <p className={styles.normalText}>{body}</p>
  }
}
export default Paragraph

type DotProps = {
  key: string
  text: string
}

const Dot: React.FC<DotProps> = ({ key, text }) => {
  return (
    <em className={styles.dots} key={key}>
      {text.split("").map((x, i) => (
        <span key={`dots_${text}_${i}`}>{x}</span>
      ))}
    </em>
  )
}

type RubyProps = {
  key: string
  text: string
  value: string
}

const Ruby: React.FC<RubyProps> = ({ text, value }) => {
  return (
    <>
      <span className={styles.ruby}>
        <span className={styles.rt} aria-hidden="true">
          {value.split("").map((x, i) => (
            <span key={`rt_${value}_${i}`}>{x}</span>
          ))}
        </span>
        <span className={styles.rb} aria-hidden="true">
          {text.split("").map((x, i) => (
            <span key={`rb_${value}_${i}`}>{x}</span>
          ))}
        </span>
      </span>
      <ruby>
        {text}
        <rp>(</rp>
        <rt>{value}</rt>
        <rp>)</rp>
      </ruby>
    </>
  )
}

type ExclamationProps = {
  key: string
  text: string
}

const Exclamation: React.FC<ExclamationProps> = ({ text }) => {
  return (
    <>
      <span className={styles.exclamation}>{text}</span>
    </>
  )
}
